import { AdminButton, AdminSection, Notice } from "./AdminPrimitives";
import { useAdminAction } from "../../hooks/useAdmin";

/**
 * 운영 액션 — 설정을 바꾼 뒤 다음 폴링 주기를 기다리지 않고 바로 확인하기 위한 버튼들.
 */
export default function OpsActionPanel({ token }: { token: string | null }) {
  const action = useAdminAction(token);

  return (
    <AdminSection
      title="운영 액션"
      description="설정 변경은 저장 즉시 반영되지만, 화면의 상태 값은 다음 폴링(기본 1분)에 갱신됩니다. 바로 확인하려면 즉시 폴링을 실행하세요."
    >
      <div className="space-y-3">
        {action.error && <Notice tone="error">{action.error.message}</Notice>}
        {action.data && <Notice tone="success">{action.data.message}</Notice>}

        <div className="flex flex-wrap gap-2">
          <AdminButton
            tone="primary"
            disabled={action.isPending}
            onClick={() => action.mutate("poll")}
          >
            {action.isPending ? "실행 중…" : "즉시 폴링"}
          </AdminButton>
          <AdminButton
            disabled={action.isPending}
            onClick={() => action.mutate("cache-clear")}
          >
            상태 캐시 비우기
          </AdminButton>
        </div>

        <p className="text-[11px] leading-relaxed text-slate-400 dark:text-slate-500">
          캐시를 비우면 화면이 잠시 '확인 중'으로 돌아갔다가 다음 폴링이 다시 채웁니다.
          직전 상태 기록도 함께 지워지므로 이 때문에 Teams 알림이 쏟아지지는 않습니다.
          사건일지(이력)는 별도 DB 라 영향받지 않습니다.
        </p>
      </div>
    </AdminSection>
  );
}
